import {WlFavoriteEvent} from "../../webcomponents/events/WlFavorite";

const hiddenCssClass = 'hidden';
const wlFavoriteComponentSelector = 'wl-favorite';
const mobileFavoritesMarker = document.querySelector('.js-favorites-marker');
const desktopFavoritesNumber = document.querySelector('.js-favorites-number');
const mobileMenuButton = document.querySelector('.js-header-menu-mobile') as HTMLButtonElement;
const mobileMenuContent = document.querySelector('.js-header-menu-mobile-dropdown') as HTMLDivElement;
const mobileMenuDropdown = document.querySelectorAll('.js-header-menu-mobile-dropdown');
const mobileMenuSale = document.querySelector('.js-header-menu-mobile-dropdown-sale') as HTMLButtonElement;
const mobileMenuRent = document.querySelector('.js-header-menu-mobile-dropdown-rent') as HTMLButtonElement;
const mobileMenuResources = document.querySelector('.js-header-menu-mobile-dropdown-resources') as HTMLButtonElement;
const mobileMenuContents = document.querySelectorAll('.js-header-menu-mobile-dropdown-content');
const mobileMenuSaleContent = document.querySelector('.js-header-menu-mobile-dropdown-content-sale') as HTMLDivElement;
const mobileMenuRentContent = document.querySelector('.js-header-menu-mobile-dropdown-content-rent') as HTMLDivElement;
const mobileMenuResourcesContent = document.querySelector('.js-header-menu-mobile-dropdown-content-resources') as HTMLDivElement;

if (mobileFavoritesMarker) {
    document.querySelectorAll(wlFavoriteComponentSelector).forEach((item) => {
        item.addEventListener(WlFavoriteEvent.type, (e) => {
            if ((e as WlFavoriteEvent).currentFavorites.listings.size > 0) {
                mobileFavoritesMarker.classList.remove(hiddenCssClass);
            } else {
                mobileFavoritesMarker.classList.add(hiddenCssClass);
            }
        });
    });
}

if (desktopFavoritesNumber) {
    document.querySelectorAll(wlFavoriteComponentSelector).forEach((item) => {
        item.addEventListener(WlFavoriteEvent.type, (e) => {
            const numberOfFavorites: number = (e as WlFavoriteEvent).currentFavorites.listings.size;
            desktopFavoritesNumber.textContent = numberOfFavorites > 0 ? numberOfFavorites.toString() : null;
        });
    });
}

if (mobileMenuButton && mobileMenuContent) {
    const menuOpenedClass = 'opened';
    mobileMenuButton.addEventListener('click', (event: Event) => {
        event.stopPropagation()
        if (!mobileMenuButton.classList.contains(menuOpenedClass)) {
            mobileMenuContent.style.display = 'flex';
            mobileMenuButton.classList.add(menuOpenedClass);
        } else {
            mobileMenuContent.style.display = "none";
            mobileMenuButton.classList.remove(menuOpenedClass);
        }
    });
    window.onclick = function (event) {
        const targetNode = event.target as Node;
        if (mobileMenuButton.classList.contains(menuOpenedClass) &&
            (!mobileMenuContent.contains(targetNode))) {
            mobileMenuContent.style.display = "none";
            mobileMenuButton.classList.remove(menuOpenedClass);
        }
    }
    if (mobileMenuSale && mobileMenuSaleContent) {
        accordionEvents(mobileMenuSale, mobileMenuSaleContent);
    }
    if (mobileMenuRent && mobileMenuRentContent) {
        accordionEvents(mobileMenuRent, mobileMenuRentContent);
    }
    if (mobileMenuResources && mobileMenuResourcesContent) {
        accordionEvents(mobileMenuResources, mobileMenuResourcesContent);
    }
}

function accordionEvents(button: HTMLButtonElement, content: HTMLDivElement) {
    button.addEventListener('click', (event: Event) => {
        event.stopPropagation()
        const buttonClosedClass = 'collapsed';
        const contentOpenedClass = 'show';
        if (button.classList.contains(buttonClosedClass)) {
            mobileMenuDropdown.forEach(button => {
                button.classList.add(buttonClosedClass)
            })
            mobileMenuContents.forEach(content => {
                content.classList.remove(contentOpenedClass);
            })
            button.classList.remove(buttonClosedClass);
            content.classList.add(contentOpenedClass);
        } else {
            button.classList.add(buttonClosedClass);
            content.classList.remove(contentOpenedClass);
        }
    });
}
